import { connect } from 'react-redux'
import { getDepartmentLabel } from '../../../../../../redux/collaborativeIndexations/selectors'
import { Department } from './Department.jsx'

const mapStateToProps = (state) => ({
    getLabel: value => getDepartmentLabel(state, value),
})

export const DepartmentContainer = connect(
    mapStateToProps,
)(Department)
